export default "__VITE_ASSET__DsaZqrXV__"